import React, { Component } from 'react';
import Picture from '../Shared/Picture';
import ShareSocialBox from '../Shared/ShareSocialBox';

class BuyNowProductPopUp extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div>
            <div id="prodPop" className={this.props.productPopup ? ("ProductPopup global-popin-wrapper buyNow active"): ("ProductPopup global-popin-wrapper buyNow")}>
            <div className="ProductPopup global-popin-scroller">
                <div className="global-popin-centered">
                <div className="clearfix">
                <section className="overlay"></section>
                    <section className="content">
                        {this.props.isDesktop && (
                            <div className="left">
                                <Picture
                                    src={[
                                        {
                                            Url: this.props.Product.BigImage.Value + "--resize,300,300",
                                            WebpUrl: this.props.Product.BigImage.Value + "--resize,300,300--returnTypeFile,webp"
                                        },
                                        {
                                            Url: this.props.Product.BigImage.Value,
                                            WebpUrl: this.props.Product.BigImage.Value + "--returnTypeFile,webp"

                                        },
                                        {
                                            Url: this.props.Product.BigImage.Value,
                                            WebpUrl: this.props.Product.BigImage.Value + "--returnTypeFile,webp"
                                        }
                                    ]}
                                    alt={this.props.Product.BigImageAlt.Value}
                                    className="prodImage"
                                />
                                <hr/>
                                <div className="share">
                                <h3>{this.props.Product.ShareText.Value}</h3>
                                <ShareSocialBox
                                    SocialShareCopyTextFacbook={this.props.SocialShareCopyTextFacbook}
                                    SocialShareCopyTextPinttrest={this.props.SocialShareCopyTextPinttrest}
                                    SocialShareCopyTextTwitter={this.props.SocialShareCopyTextTwitter}
                                    FacebookLink={this.props.FacebookLink}
                                    PinterestLink={this.props.PinterestLink}
                                    Image={this.props.Product.BigImage.Value[0]}
                                />
                                </div>
                            </div>
                        )}
                        <div className="right">
                        <a href="#" onClick={(e) => this.props.productHidePopUp(e, "product")}><span className="close" data-test="close-button"><img src="\i\x_delete_close_denied_cross-512.png" /></span></a>
                            <div className="productContent">
                                <div className="text">
                                <h3>{this.props.Product.Title.Value}</h3>
                                <p dangerouslySetInnerHTML={{"__html": this.props.Product.Description.Value}} />
                                </div>
                                <div className="smallImageContainer">
                                <Picture
                                    src={[
                                        {
                                            Url: this.props.Product.BigImage.Value + "--resize,150,150",
                                            WebpUrl: this.props.Product.BigImage.Value + "--resize,150,150--returnTypeFile,webp"
                                        },
                                        {
                                            Url: this.props.Product.BigImage.Value + "--resize,150,150",
                                            WebpUrl: this.props.Product.BigImage.Value + "--resize,150,150--returnTypeFile,webp"
                                        },
                                        {
                                            Url: this.props.Product.BigImage.Value + "--resize,150,150",
                                            WebpUrl: this.props.Product.BigImage.Value + "--resize,150,150--returnTypeFile,webp"
                                        }
                                    ]}
                                    alt={this.props.Product.BigImageAlt.Value}
                                    className="smallImage"
                                    mobileHeight={150}
                                    mobileWidth={150}
                                />
                                </div>
                            </div>
                                <hr/>
                            <div className="buyOptions">
                                <div>
                                    <h3>{this.props.Product.BuyOnlineText.Value}</h3>
                                    <ul>
                                    {this.props.Product.BuyOnlineItems.map((item, index) => {
                                        return <li key={index}><a href={item.BuyOnlineItemUrl.Value}>{item.BuyOnlineItemText.Value}</a></li>
                                    })}
                                    </ul>
                                </div>
                                <div>
                                <h3>{this.props.Product.ProfessionalsBuyOnlineText.Value}</h3>
                                <ul>
                                    {this.props.Product.ProfessionalsBuyOnlineItems.map((item, index) => {
                                        return <li key={index}><a href={item.BuyOnlineItemUrl.Value}>{item.BuyOnlineItemText.Value}</a></li>
                                    })}
                                    </ul>
                                </div>
                            </div>
                        </div>
                   </section>
                   </div>
                </div>
            </div>
        </div>
        </div>
        );
    }
}
export default BuyNowProductPopUp;
